import { render, staticRenderFns } from "./InputsAdmin.vue?vue&type=template&id=48527158"
import script from "./InputsAdmin.vue?vue&type=script&lang=js"
export * from "./InputsAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports